
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getNoteAndComments",
      resolverType: "query",
      routePath: "/getNoteAndComments",
      httpMethod: "POST",
    });
  